import Role from "../../../../utils/roles";

export const isActiveAuditorExternalUser = (u) => {
  if (!u) return false;
  const role = String(u.role_name ?? "").trim().toLowerCase();
  return role === Role.AUDITOR.toLowerCase() && Boolean(u.is_access_active);
};

export const resolveActiveAuditorsForIds = (auditorIds, externalUsers = []) => {
  if (!Array.isArray(auditorIds) || auditorIds.length === 0) return [];
  const list = externalUsers || [];
  return auditorIds
    .map((aid) =>
      list.find(
        (u) => String(u.id) === String(aid) && isActiveAuditorExternalUser(u)
      )
    )
    .filter(Boolean);
};

export const firstActiveAuditorRowPerId = (externalUsers = []) => {
  const filtered = (externalUsers || []).filter((u) =>
    isActiveAuditorExternalUser(u)
  );
  const seen = new Set();
  const out = [];
  for (const u of filtered) {
    const k = String(u.id);
    if (seen.has(k)) continue;
    seen.add(k);
    out.push(u);
  }
  return out;
};

export const getAuditorOptions = (externalUsers) => {
  return firstActiveAuditorRowPerId(externalUsers).map((user) => ({
    value: user.id,
    label: user.name,
    subtitle: user.email,
  }));
};
